import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CopyToClipboard from 'react-copy-to-clipboard';
import TagsInput from 'react-tagsinput';
import 'react-tagsinput/react-tagsinput.css';
import './ReferralOptions.scss';
import { postRequest } from '../../../requestUtils';
import { analyticsTrack } from '../../../analyticsUtils';
import grayLogo from '../../../../assets/images/Logo_Gray.svg';
import spinner from '../../../../assets/images/spinner-DNA-2s-200px.svg';

// From http://emailregex.com/

const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const employerTweet = "I'm using @MeetClora to find high-fit consultants to match my on-demand needs. Find out how:";

const consultantTweet = "I'm using @Clora, a technology platform that matches my expertise to exciting life science companies that I otherwise don't have access to. Find out how:";

class ReferralOptions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emails: [],
      submitting: false,
      successMessage: '',
      errorMessage: '',
      existingUsersMessage: '',
      invalidEmail: false,
      tag: '',
      submittingLinkedinPost: false,
      linkedinPost: '',
      linkedinError: props.authStatus === 401 ? 'Something has gone wrong. Please try again later.' : null,
      actionBlock: props.returnFromLinkedIn ? 'linkedIn' : null,
    };

    this.changeActionBlock = this.changeActionBlock.bind(this);
    this.changeLinkedinPost = this.changeLinkedinPost.bind(this);
    this.submitEmails = this.submitEmails.bind(this);
    this.submitLinkedinPost = this.submitLinkedinPost.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.onValidationReject = this.onValidationReject.bind(this);
  }

  onValidationReject(values) {
    if (values && values.length && values[0].trim() !== '') {
      this.setState({ invalidEmail: true });
    }
  }

  handleInputChange(emails) {
    this.setState({ emails, invalidEmail: false });
  }

  handleEmailChange(input) {
    if (input === ' ' || input === ';' || input === ',') {
      return;
    }

    this.setState({ tag: input });
  }

  submitEmails() {
    const { emails } = this.state;
    const {
      csrfToken, newReferralPath, location, referredUserType,
    } = this.props;

    if (!emails.length) {
      return;
    }
    this.setState({ submitting: true });

    postRequest(
      newReferralPath,
      { emails, referred_user_type: referredUserType },
      csrfToken,
    ).then(({ data: { valid, invalid, already_member: ignored } }) => {
      const errEmails = invalid.map((referral) => referral.email);

      let errorMsg = '';
      if (invalid.length) {
        errorMsg = `You've already shared a referral link with ${errEmails.join(', ')}.`;
      }

      let successMsg = '';
      if (valid.length) {
        const plural = valid.length !== 1 ? 's' : '';
        const list = valid.map((referral) => referral.email).join(', ');
        successMsg = `Email${plural} sent! Recipient${plural}: ${list}`;
      }

      let existingUsersMsg = '';
      if (ignored.length) {
        const ignoredEmails = ignored.map((referral) => referral.email).join(', ');
        existingUsersMsg = `These referrals are already Clora members: ${ignoredEmails}`;
      }

      this.setState({
        errorMessage: errorMsg,
        successMessage: successMsg,
        existingUsersMessage: existingUsersMsg,
        emails: errEmails,
        submitting: false,
      });

      this.props.addReferrals(valid);

      analyticsTrack('Clicked on Send invite emails', { location, referred_user_type: referredUserType });
    }).catch(() => {
      this.setState({
        errorMessage: 'Something has gone wrong. Please try again later',
        successMessage: '',
        submitting: false,
      });
    });
  }

  submitLinkedinPost() {
    const { linkedinPost } = this.state;
    const { csrfToken, shareOnLinkedinUrl } = this.props;

    this.setState({ submittingLinkedinPost: true });

    postRequest(
      shareOnLinkedinUrl,
      { share_commentary: linkedinPost },
      csrfToken,
    ).then(() => {
      this.setState({
        submittingLinkedinPost: false,
        sharedOnLinkedin: true,
        linkedinError: null,
      });
      analyticsTrack('Clicked on Share On LinkedIn', { location });
    }).catch(() => {
      this.setState({
        submittingLinkedinPost: false,
        linkedinError: 'Something has gone wrong. Please try again later.',
        sharedOnLinkedin: false,
      });
    });
  }

  changeActionBlock(actionType) {
    return () => (
      this.setState({ actionBlock: actionType })
    );
  }

  changeLinkedinPost(event) {
    this.setState({ linkedinPost: event.target.value });
  }

  renderTitle() {
    const { heroCopy, isConsultant, referredUserType } = this.props;
    if (heroCopy) {
      return (
        <div>
          <h1 className="mt-3 mb-4">{heroCopy}</h1>
          <div className="body-text-1 mb-4">
            {referredUserType === 'consultant' ? 'Refer consultants and get $500 when they match to a project!'
              : 'Would you like to help friends or colleagues also find talent faster?'}
          </div>
        </div>
      );
    }
    if (isConsultant && referredUserType === 'consultant') {
      return (
        <h1 className="mt-3 mb-4">
          <span className="green-highlight">Invite Consultants</span>
          {' '}
          and
          earn $500 when they are hired for their first project!
        </h1>
      );
    } if (isConsultant && referredUserType === 'employer') {
      return (
        <h1 className="mt-3 mb-4">
          <span className="purple-highlight">Invite Employers</span>
          {' '}
          and
          earn $500 when they hire their first consultant!
        </h1>
      );
    }
    return (
      <div>
        <h1 className="mt-3 mb-2">Accelerate the life science industry.</h1>
        <div className="body-text-1 mb-4">
          Refer employers and get $500 when their projects match a
          consultant!
        </div>
      </div>
    );
  }

  renderActionBlock() {
    const {
      referralPath, referredUserType, location, authCodeUrl,
    } = this.props;
    const {
      actionBlock, submittingLinkedinPost, sharedOnLinkedin, linkedinError,
    } = this.state;

    if (actionBlock === 'copy') {
      analyticsTrack('Clicked on Copy referral link', { location });
      return (
        <div className="input-group copy-link mt-2" id={`${referredUserType === 'consultant' ? 'consultant' : 'employer'}-copy-referral-link`}>
          <input className="form-control fs-hide" type="text" value={referralPath.replace(/https?:\/\//, '')} readOnly />
          <span className="input-group-addon">Copied!</span>
        </div>
      );
    } if (actionBlock === 'linkedIn') {
      analyticsTrack('Clicked on Post It to LinkedIn', { location });
      if (submittingLinkedinPost) {
        return (
          <div className="mt-3 text-center">
            <hr className="mt-0 mb-1" />
            <img src={spinner} alt="" />
            <a
              role="button"
              href="# "
              className="btn linkedin-btn full-width-btn"
              disabled
            >
              Sharing...
            </a>
          </div>
        );
      }

      if (sharedOnLinkedin) {
        return (<div className="mt-4 text-center text-primary">Shared!</div>);
      }

      if (authCodeUrl) {
        return (
          <div>
            <hr className="mt-3 mb-2" />
            <a
              role="button"
              tabIndex={0}
              href={authCodeUrl}
              onClick={() => analyticsTrack('Clicked on Connect to LinkedIn', { location })}
              className={`btn linkedin-btn full-width-btn ${referredUserType === 'consultant' ? 'consultant' : 'employer'}-connect-to-linkedin`}
            >
              Connect to LinkedIn
            </a>
            {linkedinError
            && <div className="text-danger mt-5">{linkedinError}</div>}
          </div>
        );
      }

      return (
        <div className="mt-3">
          <hr className="mt-0 mb-2" />

          <div className="mb-5">
            <textarea
              name="share_commentary"
              className="form-control"
              placeholder="Add a personal message to the post..."
              onChange={this.changeLinkedinPost}
            />
          </div>

          <div className="mb-2 grey-border small-text px-3 py-3 line-height-20">
            <strong>
              {referredUserType === 'consultant'
                ? 'Find your next opportunity in days not weeks'
                : 'Find your next consultant in days not weeks'}
            </strong>
            <div className="mt-2">{referralPath}</div>
            <div className="mt-2">
              Life Science marketplace to match biotech companies with on-demand expertise.
            </div>
          </div>

          <a
            role="button"
            href="# "
            className={`btn linkedin-btn full-width-btn ${referredUserType === 'consultant' ? 'consultant' : 'employer'}-share-on-linkedin`}
            onClick={this.submitLinkedinPost}
          >
            Share on LinkedIn
          </a>
          {linkedinError
          && <div className="text-danger mt-5">{linkedinError}</div>}
        </div>
      );
    }
    return null;
  }

  render() {
    const {
      referralPath,
      referredUserType,
      location,
      showSocialMediaShareButtons,
      isConsultant,
    } = this.props;
    const {
      errorMessage,
      successMessage,
      existingUsersMessage,
      emails,
      invalidEmail,
      tag,
    } = this.state;
    const addKeys = [9, 13, 32, 186, 188]; // tab, enter, non-printing space, semi-colon, comma

    const tweet = referredUserType === 'consultant' ? consultantTweet : employerTweet;
    const tweetText = encodeURIComponent(tweet);
    const tweetHashtags = encodeURIComponent('Clora');
    const tweetUrl = encodeURIComponent(referralPath);

    return (
      <div className="invite-modal-body style-guide">
        <div className="text-center">
          <div><img src={grayLogo} alt="Clora Logo" height="40" width="93" /></div>
          {this.renderTitle()}
        </div>

        <div className="body">

          <div>
            <label htmlFor="email-addresses" className="mt-0 body-text-2 medium emails-label mb-2">
              <strong>Send my referral link by email:</strong>
            </label>
          </div>

          <div className="form-inline flex">
            <TagsInput
              value={emails}
              onChange={this.handleInputChange}
              onChangeInput={this.handleEmailChange}
              className="form-control email-addresses fs-hide"
              addKeys={addKeys}
              inputProps={{
                placeholder: emails.length === 0 ? 'Enter email addresses...' : '',
                className: emails.length !== 0 && tag === '' ? 'react-tagsinput-input no-width' : ' react-tagsinput-input',
              }}
              inputValue={tag}
              addOnBlur
              validationRegex={emailRegex}
              onValidationReject={this.onValidationReject}
            />

            <button
              type="button"
              onClick={this.submitEmails}
              className={`${isConsultant ? 'consultant' : 'employer'}-submit-emails btn btn-primary d-flex gap-2 align-items-center ${this.state.submitting && 'disabled'} ${isConsultant && 'is-consultant'}`}
            >
              <span className="d-none d-md-block">Send </span>
              Invite
            </button>
          </div>

          {invalidEmail
            && <div className="text-danger mt-5">Please enter a valid email address.</div>}
          {successMessage && <div className="text-primary mt-5">{successMessage}</div>}
          {errorMessage && <div className="text-danger mt-5">{errorMessage}</div>}
          {existingUsersMessage && <div className="mt-5">{existingUsersMessage}</div>}

          { showSocialMediaShareButtons

            && (
            <div>
              <div className="g-row--always g-column--centered small-text action-separator">
                <span className="grey-separator" />
                <span className="pr-10 ps-3">or</span>
                <span className="grey-separator" />
              </div>

              <div className="action-buttons d-flex flex-column flex-md-row gap-3 justify-content-between">
                <CopyToClipboard text={referralPath}>
                  <button type="button" onClick={this.changeActionBlock('copy')} className="btn btn-primary">
                    <i className="fas fa-link" />
                    <span className="ps-3">Copy it</span>
                  </button>
                </CopyToClipboard>

                <button
                  type="button"
                  onClick={this.changeActionBlock('linkedIn')}
                  className={`btn linkedin-btn ${referredUserType === 'consultant' ? 'consultant' : 'employer'}-post-it`}
                >
                  <i className="fab fa-linkedin-in" />
                  <span className="ps-3">Post it</span>
                </button>

                <a
                  role="button"
                  tabIndex={0}
                  className={`twitter-share-btn btn ${referredUserType === 'consultant' ? 'consultant' : 'employer'}-tweet-it`}
                  href={`https://twitter.com/intent/tweet?text=${tweetText}&url=${tweetUrl}&hashtags=${tweetHashtags}`}
                  onClick={() => analyticsTrack('Clicked on Tweet It to Twitter', { location })}
                >
                  <i className="fab fa-twitter" />
                  <span className="ps-3">Tweet it</span>
                </a>
              </div>
              {this.renderActionBlock()}
            </div>
            )}
        </div>
      </div>
    );
  }
}

ReferralOptions.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  referralPath: PropTypes.string.isRequired,
  newReferralPath: PropTypes.string.isRequired,
  addReferrals: PropTypes.func,
  returnFromLinkedIn: PropTypes.bool,
  shareOnLinkedinUrl: PropTypes.string.isRequired,
  authCodeUrl: PropTypes.string,
  authStatus: PropTypes.number,
  referredUserType: PropTypes.string.isRequired,
  heroCopy: PropTypes.string,
  location: PropTypes.string.isRequired,
  isConsultant: PropTypes.bool,
  showSocialMediaShareButtons: PropTypes.bool,
};

ReferralOptions.defaultProps = {
  returnFromLinkedIn: false,
  authCodeUrl: null,
  authStatus: null,
  addReferrals: () => null,
  isConsultant: true,
  showSocialMediaShareButtons: true,
  heroCopy: null,
};

export default ReferralOptions;
